export const TaxInvoiceLabel = {
  Add: "Add",
  Update: "Update",
  TaxInvoiceTitle: "Tax Invoice",
  TaxInvoice: "Tax Invoice",
  TaxInvoiceNo: "Tax Invoice No",
  VendorName: "Customer Name",
  VendorId: "Customer ID",
  TaxInvoiceDT: "Tax Invoice Date",
  TaxableValue: "Taxable Value",
  GST: "GST",
  TaxInvoiceAmt: "Tax Invoice Amount",
  Warranty: "Warranty",
  Remarks: "Remarks",
  ProformaInvoice: "Proforma Invoice",
  ProformaInvoiceDate: "Proforma Invoice Date",
  ProformaInvoiceDT: "Proforma Invoice Date",
  ProformaInvoiceNo: "Proforma Invoice No",
  workOrderNo: "Work Order No.",
  includeTax: "(INCL OF TAX)",
  valueFromWorkOrder: "(Value from Work Order)",
  totalAmount: "Total Amount"
};
export const ConditionOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
];
export const TaxInvoiceKey = {
  VendorName: "customer_name",
  VendorID: "customer_id",
  TaxInvoice: "tax_in_no",
  TaxInvoiceDT: "tax_in_dt",
  TaxableValue: "taxable",
  GST: "gst",
  TaxInvoiceAmt: "tax_invoice_amount",
  Warranty: "warranty",
  Remarks: "remarks",
};
export const dummyData = [
  {
    vendor_name: "John Doe",
    vendor_id: "30",
    quote_no: "162",
    quote_amt: "80000",
    wo_no: "3",
    wo_amount: "2000",
    wo_date: "20/06/2024",
    quotation_date: "09/06/2024",
    proforma_invoice: "1",
    proforma_dt: "2",
    taxable_value: "200",
    gst: "18%",
    tax_invoice: "12",
    warranty: "No",
    remarks: "remarks",
    ship_to: "Ahmedabad",
    bill_to: "XYZ",
    delivery_note: "N/A",
    delivery_date: "12-04-2024",
    terms_of_payment: "Advanced",
    reference_no_date: "10-04-2024 12",
    vehicle_reg_no: "GRN027504",
    serial_no: "3",
    engine_no: "0456",
    buyer_order_no: "1",
    buyer_date: "03-11-2023",
    dispatched_through: "BlueDart",
    destination: "Surat",
    motor_vehicle_no: "GJ04-RJ-2345",
    delivery_terms: "On Payment",
    sr_no: 2,
    description_of_goods: "material",
    description_sub_head: "add",
    hsn_sac: "HSN001",
    quotation_gst: "12%",
    quantity: "300",
    rate: "400",
    per: "40",
    amount: "120000",
  },
  {
    vendor_name: "John Doe",
    vendor_id: "30",
    quote_no: "162",
    quote_amt: "80000",
    wo_no: "3",
    wo_amount: "2000",
    wo_date: "20/06/2024",
    quotation_date: "09/06/2024",
    proforma_invoice: "1",
    proforma_dt: "2",
    taxable_value: "200",
    gst: "18%",
    tax_invoice: "12",
    warranty: "No",
    remarks: "remarks",
    ship_to: "Ahmedabad",
    bill_to: "XYZ",
    delivery_note: "N/A",
    delivery_date: "12-04-2024",
    terms_of_payment: "Advanced",
    reference_no_date: "10-04-2024 12",
    vehicle_reg_no: "GRN027504",
    serial_no: "3",
    engine_no: "0456",
    buyer_order_no: "1",
    buyer_date: "03-11-2023",
    dispatched_through: "BlueDart",
    destination: "Surat",
    motor_vehicle_no: "GJ04-RJ-2345",
    delivery_terms: "On Payment",
    sr_no: 1,
    description_of_goods: "material",
    description_sub_head: "add",
    hsn_sac: "HSN001",
    quotation_gst: "12%",
    quantity: "300",
    rate: "400",
    per: "40",
    amount: "120000",
  },
];
